module.exports = __webpack_public_path__ + "assets/pin_onMarket.dc54193c.svg";